import React, { forwardRef, useEffect } from 'react';
import { getImage, getImageError } from "estimate_list/libs/item";
import { XIcon } from "estimate_list/assets/Icons";
import Zzim from "estimate_list/components/list/zzim";
import styled from "styled-components";
import { numberFormat } from "estimate_list/libs/util";
import { useDispatch } from "react-redux";
import { SET_COMPARE_VIEW } from "estimate_list/libs/action";

const CompareViewTop = forwardRef((props, ref) => {
    const dispatch = useDispatch()
    const {itemList, setItemList, isPrinting, urlSearchCateId, handleScrollTop, urlItemId, setUrlItemId, bottomSize} = props
    const topWidth = (190 * itemList.length) + 1 + 'px'

    const onMouseOverlikeHandler = (index) => {
        const element = document.getElementById(`like_icon_${index}`)
        if (element) {
            element.className = 'icon-favorite'
        }
    }

    const onMouseLeavelikeHandler = (index) => {
        const element = document.getElementById(`like_icon_${index}`)
        if (element) {
            element.className = 'icon-favorite_border'
        }
    }

    /**
     * 비 로그인 시 찜하기 누른 후 모달창 취소하면 회색 하트 유지되는 문제 해결
     * @param index
     * @param item_zzim_my
     */
    const changeLikeDefault = (index, itemZzimMy) => {
        const element = document.getElementById(`like_icon_${index}`)
        if (element && element.className === 'icon-favorite' && itemZzimMy === 0) {
            element.className = 'icon-favorite_border'
        }
    }

    /**
     * 상품 삭제 및 url 변경
     * @param itemId
     */
    const deleteItem = (itemId) => {
        const urlItemIdList = urlItemId.split(",")
        const filteredList = urlItemIdList.filter(v => v !== itemId)
        const joinList = filteredList.join(",")
        const encodeItemIdList = encodeURIComponent(joinList)
        const result = itemList.filter(v => (v.item_id !== itemId))
        dispatch({
            type: SET_COMPARE_VIEW,
            compareView: result
        })
        setUrlItemId(joinList)
        window.history.pushState('', null, `/compare_spec/${urlSearchCateId}/${encodeItemIdList}`);
    }

    const handleSetPriceTabHeight = () => {
        const itemName = document.querySelector(".pname_td")
        const leftPriceTab = document.querySelector(".title_top_left.product")
        let priceItemHeight = itemName.getBoundingClientRect().height
        if (leftPriceTab) {
            leftPriceTab.style.height = `${priceItemHeight-1}px`
        }
    }

    const handleSetHeadTopHeight = () => {
        const topArea = document.querySelector(".fix_area_top")
        const headTop = document.querySelector(".scroll_head_top")
        const topLeftTab = document.querySelector(".scroll_head_top_left_fixed")
        const leftTabHeight = topLeftTab.getBoundingClientRect().height
        if (headTop) {
            headTop.style.height = `${leftTabHeight}px`
            topArea.style.height = `${leftTabHeight}px`
        }
    }

    // 상단 좌우측 영역 두세줄일 떄 높이값 맞춤
    useEffect(() => {
        handleSetPriceTabHeight()
        handleSetHeadTopHeight()
    },[])

    return (
        <ContentTopTable  className="fix_area_top">
            <div className="fix_head fix_head_top">
                <div className="scroll_head_top" style={{height: "263px", width: `${bottomSize.width}px'}`}}>
                    <div className="scroll_head_top_flex">
                        <div className="scroll_head_top_left_wrap">
                            <table className="scroll_head_top_left_fixed">
                                <tbody>
                                    <tr className="title_top_left_tr">
                                        <th className="title_top_left image">
                                            이미지
                                        </th>
                                    </tr>
                                    <tr className="title_top_left_tr">
                                        <th className="title_top_left product">
                                            상품명
                                        </th>
                                    </tr>
                                    <tr className="title_top_left_tr">
                                        <th className="title_top_left price">
                                            가격
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div
                            className="scroll"
                            ref={ref}
                            onScroll={handleScrollTop}
                        >
                            <div className="scroll_top_table_wrap" style={{width: topWidth}}>
                                <table>
                                    <tbody>
                                        <tr className="basic">
                                            {itemList.map((item,i) => {
                                                const {item_info, item_id} = item
                                                const {zzim_my} = item_info
                                                const imgSrc = getImage(zzim_my, item_id, 140)

                                                return (
                                                    <td className="item_compare_thumnail">
                                                        <ItemThumnail href={`${process.env.REACT_APP_SHOPPING_URL}/detail/${item_id}`} target="_blank" style={{width: "189px"}}>
                                                            <span className="pimg">
                                                                <img
                                                                    src={imgSrc.imgUrl}
                                                                    onError={e => getImageError(e, imgSrc.noImgUrl)}
                                                                    alt=""
                                                                />
                                                            </span>
                                                        </ItemThumnail>
                                                        {!isPrinting &&
                                                            <ItemXButton onClick={() => deleteItem(item_id)} >
                                                                <XIcon/>
                                                            </ItemXButton>
                                                        }
                                                        {!isPrinting &&
                                                            <ZzimItemCompare
                                                                onMouseOver={() => onMouseOverlikeHandler(i)}
                                                                onMouseOut={() => onMouseLeavelikeHandler(i)}
                                                                onClick={() => changeLikeDefault(i, zzim_my)}
                                                            >
                                                                <Zzim
                                                                    f_div={4}
                                                                    idx={item_id}
                                                                    selected={zzim_my > 0 ? true : false}
                                                                    count={zzim_my}
                                                                    pageType={1}
                                                                    index={i}
                                                                    itemCompareList={itemList}
                                                                    setItemList={setItemList}
                                                                >
                                                                    <input value={i} type="hidden" />
                                                                    {zzim_my === 1 ?
                                                                        <i className="icon-favorite" style={{ color: '#3281ED' }}></i> :
                                                                        <i className="icon-favorite_border" id={`like_icon_${i}`}>
                                                                        </i>
                                                                    }
                                                                </Zzim>
                                                            </ZzimItemCompare>
                                                        }
                                                    </td>
                                                )
                                            })
                                            }
                                        </tr>
                                        <tr className="basic">
                                            {itemList.map(item => (
                                                <td className="pname_td">
                                                    <a href={`${process.env.REACT_APP_SHOPPING_URL}/detail/${item.item_id}`} target="_blank">
                                                        <span className="pname">{item.item_info.item_name}</span>
                                                    </a>
                                                </td>
                                            ))}
                                        </tr>
                                        <tr className="basic">
                                            {itemList.map(item => (
                                                <td className="item_price_td">
                                                    <span className="item_price">
                                                        {item.item_info.price_low !== 0 ? (
                                                            <>
                                                                <strong>{numberFormat(item.item_info.price_low)}</strong>
                                                                <span>원</span>
                                                            </>
                                                        ): <span>가격비교 예정</span>
                                                        }
                                                    </span>
                                                </td>
                                            ))}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ContentTopTable>
    );
});

export default CompareViewTop;

const ContentTopTable = styled.div`
    .scroll {
        overflow: auto;
        overflow-y: hidden;
    }
    .scroll_head_top {
        display: flex;
        overflow: hidden;
    }
    .scroll_head_top_flex{
        display: flex;
        overflow: scroll;
        overflow-y: hidden;

        border-top: 1px solid #707070;
        border-bottom: 1px solid #707070;
    }
    .scroll_head_top_left_wrap {
        border-right: 1px solid #707070;
    }
    .scroll_head_top_left_fixed {
        width: 73px;
        table-layout: fixed;
        border-left: 1px solid #e5e5e5;
    }
    .scroll_top_table_wrap {
        overflow: hidden;
        table-layout: fixed;
    }
    .scroll::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera*/
    }
    .item_price_td {
        padding: 16px 0;
    }
    .pname_td {
        height: 36px;
        padding: 15px 24px;
        font-family: 'Noto Sans KR';
        font-size: 13px;
        font-weight: bold;
        line-height: 19px;
    }
    .title_top_left {
        font-family: 'Noto Sans KR';
        font-weight: 400;
    }
    .title_top_left.image {
        height: 141px;
    }
    .title_top_left.product {
        height: 68px;
    }
    .title_top_left.price {
        height: 50px;
    }
    .title_top_left_tr {
        border-bottom: 1px solid #e5e5e5;
    }
    table {
        th {
            padding: 0 10px;
            background-color: #f7f7f7;
        }
        td {
            text-align: center;
            width: 180px;
            padding: 20px 0;
            border: 1px solid #e5e5e5;
            position: relative;
        }
    }
`;

const ZzimItemCompare = styled.span`
    height: 20px;
    position: absolute;
    bottom: 5px;
    right: 5px;

    .button.zzim {
        border: none;
        background-color: transparent;
    }
    .icon-favorite {
        color: #c8c8c8;
        font-size: 19px;
    }
    .icon-favorite_border {
        color: #3281ed;
        font-size: 19px;
    }

    .iradio label:before {
        width: 16px;
        height: 16px;
        vertical-align: middle;
        padding: 3px;
        margin-right: 5px;
    }

    .iradio input:checked + label:after {
        width: 16px;
        height: 16px;
        left: 4px;
        top: 4px;
        margin-top: 0;
    }
`;

const ItemThumnail = styled.a`
    img {
        border: 1px solid #fff;
        &:hover {
            border: 1px solid #3281ed;
        }
    }
`;
const ItemXButton = styled.button`
    border: none;
    background-color: transparent;
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 20;

    &:hover {
        path {
            stroke: #3281ed;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/estimate_list/components/compareview/compareViewTop.js